import AnalyticsEvent from '@monolith/legacy/services/analytics/events/analytics-event';
import { CatalogSortEventName, CatalogSortEventProperties } from '@monolith/legacy/services/analytics/properties/catalog-sort-property';

export class CatalogSortEvent extends AnalyticsEvent {
  public name: CatalogSortEventName;
  public properties: CatalogSortEventProperties;

  constructor({ name, properties }: { name: CatalogSortEventName; properties: CatalogSortEventProperties }) {
    super();
    this.name = name;
    this.properties = properties;
  }
}
